module.exports = __webpack_public_path__ + "static/media/Cancellation.dabdd2d4.svg";